import React, { useState, useEffect } from 'react';
import './App.css';

const App = () => {
  const [activeSection, setActiveSection] = useState('home');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('section');
      const scrollPos = window.scrollY + 100;

      sections.forEach(section => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.clientHeight;
        
        if (scrollPos >= sectionTop && scrollPos < sectionTop + sectionHeight) {
          setActiveSection(section.id);
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="App">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-logo">
            <img src="/images/h-icon.png" alt="Hubble Protocol" className="logo-img" />
            <span className="logo-text">Hubble</span>
          </div>
          
          {/* Mobile Menu Button */}
          <button 
            className={`mobile-menu-btn ${isMenuOpen ? 'active' : ''}`}
            onClick={toggleMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
            <li className="nav-item">
              <a 
                href="#home" 
                className={`nav-link ${activeSection === 'home' ? 'active' : ''}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </a>
            </li>
            <li className="nav-item">
              <a 
                href="#journey" 
                className={`nav-link ${activeSection === 'journey' ? 'active' : ''}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Journey
              </a>
            </li>
            <li className="nav-item">
              <a 
                href="#tokens" 
                className={`nav-link ${activeSection === 'tokens' ? 'active' : ''}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Tokens
              </a>
            </li>
            <li className="nav-item">
              <a 
                href="#roadmap" 
                className={`nav-link ${activeSection === 'roadmap' ? 'active' : ''}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Roadmap
              </a>
            </li>
            <li className="nav-item">
              <a 
                href="#about" 
                className={`nav-link ${activeSection === 'about' ? 'active' : ''}`}
                onClick={() => setIsMenuOpen(false)}
              >
                About
              </a>
            </li>
            <li className="nav-item">
              <a 
                href="https://app.xhubble.xyz" 
                className="nav-link launch-app-btn"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setIsMenuOpen(false)}
              >
                Launch App
              </a>
            </li>
          </ul>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="hero-bg">
          <img src="/images/bg.gif" alt="Space Background" className="bg-gif" />
          <div className="bg-overlay"></div>
        </div>
        <div className="hero-content">
          <div className="hero-text">
            <div className="logo-section">
              <img src="/images/h-icon.png" alt="Hubble" className="hero-logo" />
              <h1 className="hero-title">
                Hubble <span className="highlight">Protocol</span>
              </h1>
            </div>
            <p className="hero-subtitle">
              An evolution of Tomb Finance on Sonic
            </p>
            <p className="hero-description">
              Hubble uses redemption and minting fees to increase the backing and remains partially backed at all times.
            </p>
            <div className="hero-buttons">
              <a 
                href="https://app.xhubble.xyz" 
                className="btn btn-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                Launch App
              </a>
              <a href="#journey" className="btn btn-secondary">
                Explore Journey
              </a>
            </div>
          </div>
          <div className="hero-visual">
            <div className="edwin-container">
              <img src="/images/cute-edwin.png" alt="Edwin the Cat Astronaut" className="edwin-image" />
              <div className="floating-planets">
                <img src="/images/planet.png" alt="Planet" className="planet planet-1" />
                <img src="/images/planet.png" alt="Planet" className="planet planet-2" />
                <img src="/images/uwu.png" alt="UwU Edwin" className="planet planet-3" />
              </div>
            </div>
          </div>
        </div>
        <div className="scroll-indicator">
          <span>Scroll to explore</span>
          <div className="scroll-arrow"></div>
        </div>
      </section>

      {/* Journey Section */}
      <section id="journey" className="journey">
        <div className="section-container">
          <h2 className="section-title">
            Our <span className="highlight">Journey</span>
          </h2>
          <div className="timeline">
            <div className="timeline-item">
              <div className="timeline-date">February 2025</div>
              <div className="timeline-icon">
                <img src="/images/planet.png" alt="Launch" />
              </div>
              <div className="timeline-content">
                <h3>Stealth Launch</h3>
                <p>4800 HUBBLE in a range order starting at 1 USDC on Shadow.so, marking the beginning of our cosmic journey in the DeFi space on Sonic.</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-date">March 2025</div>
              <div className="timeline-icon">
                <img src="/images/uwu.png" alt="Genesis" />
              </div>
              <div className="timeline-content">
                <h3>Genesis Event</h3>
                <p>10-day emission event distributing 4800 HUBBLE through a mix of xHUBBLE and HUBBLE, to over a dozen community tokens, establishing the foundation of our protocol's tokenomics and community.</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-date">Apr - June 2025</div>
              <div className="timeline-icon">
                <img src="/images/h-icon.png" alt="Stability" />
              </div>
              <div className="timeline-content">
                <h3>Alpha I</h3>
                <p>The first alpha phase used a Black Hole mechanic to allow redemptions when certain conditions were met. This phase was successful but multiple improvements were made leading to Alpha II. </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-date">June - Nov 2025</div>
              <div className="timeline-icon">
                <img src="/images/h-icon.png" alt="Stability" />
              </div>
              <div className="timeline-content">
                <h3>Alpha II</h3>
                <p>Alpha II introduced perpetual redemption and minting linked to the current backing ratio of $EX. This helps keep the $EX peg more stable. Emission rates for $xEX were also adjusted to better reflect the strength of the peg.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Tokens Section */}
      <section id="tokens" className="tokens">
        <div className="section-container">
          <h2 className="section-title">
            Protocol <span className="highlight">Tokens</span>
          </h2>
          <div className="tokens-grid">
            <div className="token-card">
              <div className="token-icon">
                <img src="/images/h-icon.png" alt="HUBBLE" />
              </div>
              <h3>HUBBLE</h3>
              <p>The core token of the Hubble Protocol ecosystem. Used for governance.</p>
            </div>
            <div className="token-card">
              <div className="token-icon">
                <img src="/images/x-icon.png" alt="xHUBBLE" />
              </div>
              <h3>xHUBBLE</h3>
              <p>180-day locked HUBBLE, used for staking and governance.</p>
            </div>
            <div className="token-card">
              <div className="token-icon">
                <img src="/images/ex.png" alt="EX" />
              </div>
              <h3>EX</h3>
              <p>Pegged to $stS - Beets Staked Sonic, $EX is a yield bearing algo-stable.</p>
              <div className="peg-badge">Pegged to $stS</div>
            </div>
            <div className="token-card">
              <div className="token-icon">
                <img src="/images/xEX.png" alt="xEX" />
              </div>
              <h3>xEX</h3>
              <p>14-day locked EX for staking.</p>
            </div>
            
          </div>
          <div className="token-mechanics">
            <h3>Token Mechanics</h3>
            <p>
              $EX maintains a peg to $stS, creating a stable foundation for the Hubble ecosystem. 
              The protocol uses redemption and minting fees to systematically increase backing, 
              ensuring partial backing is maintained through all market conditions.
            </p>
          </div>
        </div>
      </section>

      {/* Roadmap Section */}
      <section id="roadmap" className="roadmap">
        <div className="section-container">
          <h2 className="section-title">
            Future <span className="highlight">Plans</span>
          </h2>
          <div className="roadmap-grid">
            <div className="roadmap-phase">
              <div className="phase-header">
                <img src="/images/uwu.png" alt="Current Phase" className="phase-icon" />
                <h3 className="phase-title">Current Development</h3>
              </div>
              <ul className="phase-items">
                <li>Finalize review of new epochs contract</li>
                <li>Launch Alpha 3 with new epochs contract</li>
                <li>Update Engine page with new automations</li>
                <li>~Edwin Space Credit to FeeM $S ~ (complete)</li>
                <li>Put someone in charge of Social Media</li>
                <li>Review MacePapa's open source site version</li>
              </ul>
            </div>
            <div className="roadmap-phase">
              <div className="phase-header">
                <img src="/images/cute-edwin.png" alt="Edwin PFPs" className="phase-icon" />
                <h3 className="phase-title">Edwin PFPs & Open Source</h3>
              </div>
              <ul className="phase-items">
                <li>Edwin PFPs by Funeral, 420 Total Supply</li>
                <li>Free, airdropped to all 120+ OG stakers</li>
                <li>Other recipients: Testers, Active Users, Oracle Updaters</li>
                <li>Finalize open source version</li>
                <li>Start preparing Beta stS Vault contracts on testnet</li>
              </ul>
            </div>
            <div className="roadmap-phase">
              <div className="phase-header">
                <img src="/images/planet.png" alt="Beta" className="phase-icon" />
                <h3 className="phase-title">Beta & Decentralization</h3>
              </div>
              <ul className="phase-items">
                <li>Testnet Beta Epochs</li>
                <li>Voting on stS deposit deployment percentages</li>
                <li>Mainnet Beta Epochs</li>
                <li>Begin identifying potential multisig signers</li>
                <li>Work on initial revenue generating vaults</li>
                <li>Design voting system for final stS vault</li>
              </ul>
            </div>
            <div className="roadmap-phase">
              <div className="phase-header">
                <img src="/images/h-icon.png" alt="Launch" className="phase-icon" />
                <h3 className="phase-title">Full Protocol Launch</h3>
              </div>
              <ul className="phase-items">
                <li>2026 Q3/Q4 - Earliest full protocol launch</li>
                <li>Complete decentralization</li>
                <li>Advanced vault strategies</li>
                <li>Community governance fully operational</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about">
        <div className="section-container">
          <h2 className="section-title">
            About <span className="highlight">Hubble</span>
          </h2>
          <div className="about-content">
            <div className="about-text">
              <p>
                Hubble Protocol is an evolution of Tomb Finance on the Sonic blockchain. 
                It maintains a partially backed stablecoin system using redemption and 
                minting fees to increase the protocol's backing over time.
              </p>
              
              <div className="about-stats">
                <div className="stat">
                  <h3>17,000+</h3>
                  <p>$xHUBBLE/year</p>
                </div>
                <div className="stat">
                  <h3>48</h3>
                  <p>$xHUBBLE/day</p>
                </div>
                <div className="stat">
                  <h3>10</h3>
                  <p>years of emissions</p> 
                </div>
              </div>
            </div>
            <div className="about-visual">
              <div className="protocol-diagram">
                <div className="diagram-item">
                  <img src="/images/h-icon.png" alt="HUBBLE" />
                  <span>HUBBLE</span>
                </div>
                <div className="diagram-arrow">→</div>
                <div className="diagram-item">
                  <img src="/images/x-icon.png" alt="xHUBBLE" />
                  <span>xHUBBLE</span>
                </div>
                <div className="diagram-arrow">→</div>
                <div className="diagram-item">
                  <img src="/images/ex.png" alt="EX" />
                  <span>EX</span>
                  <div className="peg-notice">Pegged to $stS</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-logo">
            <img src="/images/h-icon.png" alt="Hubble Protocol" className="footer-logo-img" />
            <div>
              <div className="logo-text">Hubble Protocol</div>
              <p>Exploring DeFi Frontiers</p>
            </div>
          </div>
          <div className="footer-links">
            <h4>Navigation</h4>
            <a href="#home">Home</a>
            <a href="#journey">Journey</a>
            <a href="#tokens">Tokens</a>
            <a href="#roadmap">Roadmap</a>
            <a href="#about">About</a>
          </div>
          <div className="footer-app">
            <h4>Application</h4>
            <a 
              href="https://app.xhubble.xyz" 
              target="_blank" 
              rel="noopener noreferrer"
              className="app-link"
            >
              Launch Hubble App
            </a>
          </div>
          <div className="footer-social">
            <h4>Connect With Us</h4>
            <div className="social-icons">
              <a href="https://twitter.com/hubbleonsonic" target="_blank" rel="noopener noreferrer">
                <img src="/images/icon--twitter.png" alt="Twitter" />
                <span>@hubbleonsonic</span>
              </a>
              <a href="https://discord.gg/kKKrafFgCH" target="_blank" rel="noopener noreferrer">
                <img src="/images/discord.png" alt="Discord" />
                <span>Discord</span>
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 Hubble Protocol. All rights reserved.</p>
          <p>Building long term games with long term people.</p>
        </div>
      </footer>
    </div>
  );
};

export default App;